import styled from '@emotion/styled';
import shouldForwardProp from '@styled-system/should-forward-prop';
import {
  background,
  BackgroundProps,
  border,
  BorderProps,
  color,
  compose,
  display,
  DisplayProps,
  flexbox,
  FlexboxProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  shadow,
  ShadowProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system';
import {
  ColorProps,
  defineWithTheme,
  WithoutCollidingProps,
} from '../../theming';

export interface BaseSelectProps
  extends BackgroundProps,
    BorderProps,
    ColorProps,
    DisplayProps,
    FlexboxProps,
    LayoutProps,
    PositionProps,
    ShadowProps,
    SpaceProps,
    TypographyProps {}

type NonCollidingSelectProps = WithoutCollidingProps<BaseSelectProps, 'select'>;
type NonCollidingSelectKeys = keyof NonCollidingSelectProps;

export const Select = styled('select', {
  shouldForwardProp: (prop): prop is NonCollidingSelectKeys =>
    shouldForwardProp(prop as NonCollidingSelectKeys),
})<BaseSelectProps>(
  defineWithTheme('selects'),
  compose(
    background,
    border,
    color,
    display,
    flexbox,
    layout,
    position,
    shadow,
    space,
    typography
  )
);

export type SelectProps = React.ComponentPropsWithoutRef<typeof Select>;
